import Mustache from 'mustache';
import Modal from '@/js/plugins/modal';
import confirmModalHtml from '@/js/html_templates/confirm-modal.html';
import { csrfToken } from '@/js/_common';

export const showConfirmModal = ({
    type = 'confirm',
    imageUrl = null,
    message = '',
    confirmMessage = '',
    actionUrl = '',
    method = '',
    token = csrfToken,
    hiddenFields = [],
    confirmText = 'OK',
    cancelText = 'キャンセルして閉じる',
    onConfirm = null,
    onCancel = null,
    size = 'medium',
    overlayClose = true,
} = {}) => {
    const modal = new Modal({ overlayClose });
    const html = Mustache.render(confirmModalHtml, {
        type,
        image_url: imageUrl,
        message,
        confirm_message: confirmMessage,
        action_url: actionUrl,
        method,
        token,
        hidden_fields: hiddenFields,
        confirm_text: confirmText,
        cancel_text: cancelText,
        size: size,
    });

    modal.setHtml(html);
    modal.show();

    const root = document.querySelector('.c-parts-confirm-modal');
    if (!root) return modal;

    root.querySelectorAll('[data-action="cancel"]').forEach((el) => {
        el.addEventListener('click', () => {
            modal.close();
            if (onCancel) onCancel();
        });
    });

    if (!actionUrl) {
        const confirmButton = root.querySelector('[data-action="confirm"]');
        if (confirmButton) {
            confirmButton.addEventListener('click', () => {
                if (onConfirm) onConfirm();
                modal.close();
            });
        }
    }

    return modal;
};

export default showConfirmModal;
